module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAP1BMVEUAAAAQEBAQEBAQEBAQEBAQEBAREREPDw8REREQEBAQEBAPDw8SEhIODg4QEBARERETExMQEBAREREQEBAUFBTlCPIjAAAAFXRSTlMA/0CAv39LdA+cjsYqR9SZG9uLnxltp592AAAApklEQVR4nO2WWQ6FMAhF5WF98+z+1+pYh0RNhGtizD3/PaGUAgkhhJB5Pre7mPm+n9GjdkvDtfE8vB6Rcy36+UWSV6IUIMoqEcAjuoXoZKLNS/rPLp3IVIJ9ghUleg1Ea+81fvKhaH2GDywKQeOf94lK4imKthQFZERaAoloX5W9EBGqjcAaG6jVmpho/i6wcw02smFLBGytSYLX0y5auNWPEELINAXJ2QuTWetZSAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/battery.png
// module id = WcnM
// module chunks = 5